export default class formConfig {
  // 银行基本户-详情
  static configList() {
    return [
      {
        title: "证书信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "所在企业：",
            type: "input",
            value: "corpBasicinfoName",
            disabled: true
          },
          {
            label: "证书类型：",
            type: "select",
            value: "regType",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201507131626360048"
            },
            rule: {
              required: true,
              message: "请选择证书类型",
              trigger: "blur"
            }
          },
          {
            label: "证书等级：",
            type: "slot",
            slotName: "regLevel",
            value: "regLevel",
            placeholder: "请输入",
            queryParams: {},
            rule: {
              required: true,
              message: "请选择证书等级",
              trigger: "blur"
            }
          },
          {
            label: "证书编号：",
            type: "input",
            value: "certNum",
            maxlength: 20,
            required: true,
            rule: {
              required: true,
              message: "请填写证书编号",
              trigger: "blur"
            }
          },
          {
            label: "发证日期：",
            type: "date",
            value: "awardDate",
            dateType: "date",
            required: true,
            clearable: true,
            valueFormat: "yyyy-MM-dd",
            rule: {
              required: true,
              message: "请选择发证日期",
              trigger: "change"
            }
          },
          {
            label: "发证单位：",
            type: "input",
            value: "awardDepart",
            maxlength: 30,
            required: true,
            rule: {
              required: true,
              message: "请填写发证单位",
              trigger: "blur"
            }
          },
          {
            label: "证书有效期：",
            type: "date",
            value: "effectDate",
            dateType: "date",
            required: true,
            clearable: true,
            valueFormat: "yyyy-MM-dd",
            rule: {
              required: true,
              message: "请选择证书有效期",
              trigger: "change"
            }
          },
          {
            label: "证书专业：",
            type: "slot",
            slotName: "regTradeTypeNum",
            value: "regTradeTypeNum",
            placeholder: "请输入",
            queryParams: {},
            rule: {
              required: true,
              message: "请选择证书专业",
              trigger: "change"
            }
          },

          {
            label: "执业资格状态：",
            type: "select",
            value: "qstate",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507131636510067"
            },
            rule: {
              required: true,
              message: "请选择执业资格状态",
              trigger: "change"
            }
          },
          {
            label: "证书开始日期：",
            type: "date",
            value: "tradeTypeAwardDate",
            dateType: "date",
            required: true,
            clearable: true,
            valueFormat: "yyyy-MM-dd",
            rule: {
              required: true,
              message: "请选择证书开始日期",
              trigger: "change"
            }
          },
          {
            label: "证书截止日期：",
            type: "date",
            value: "tradeTypeEffectDate",
            dateType: "date",
            required: true,
            clearable: true,
            valueFormat: "yyyy-MM-dd",
            rule: {
              required: true,
              message: "请选择证书截止日期",
              trigger: "change"
            }
          }
        ]
      }
    ];
  }
}
